import { FC, PropsWithChildren, ReactNode } from 'react';
import { Tooltip, Typography } from '@mui/material';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';
import Row from '../../../components/Row';
import { Campaign } from '../../../types/Campaign';
import { useUserContext } from '../../../hooks/Contexts/UserContext';

type TagProps = {
    tooltip: ReactNode;
};

const Tag: FC<PropsWithChildren<TagProps>> = ({ children, tooltip }) => (
    <Row gap={0.5}>
        <Typography variant="body2" fontStyle="italic" color="action.disabled">
            {children}
        </Typography>

        <Tooltip arrow placement="top" title={tooltip}>
            <HelpOutlineIcon color="disabled" fontSize="small" />
        </Tooltip>
    </Row>
);

interface CampaignOemProgramValueProps {
    campaign: Campaign;
}

const CampaignOemProgramValue: FC<CampaignOemProgramValueProps> = ({ campaign }) => {
    const programName = campaign?.oemProgram?.oemProgram;
    const hasAgencyOemProgram = !!campaign?.hasAgencyOemProgram;

    const { userContext } = useUserContext();

    if (programName) {
        return <Typography variant="body2">{programName}</Typography>;
    }

    if (hasAgencyOemProgram) {
        return <Tag tooltip="Assign OEM Program to Campaign if it should be tagged.">No Program Assigned</Tag>;
    }

    if (userContext.isAdvertiser()) {
        return (
            <Tag tooltip="Assign OEM Program to Advertiser and Campaign if it should be tagged..">
                No Program Available - Advertiser
            </Tag>
        );
    }

    return (
        <Tag tooltip="Assign OEM Program to Agency, Advertiser and Campaign if it should be tagged.">
            No Program Available - Agency
        </Tag>
    );
};

export type { CampaignOemProgramValueProps };
export default CampaignOemProgramValue;
